export default __webpack_public_path__ + "static/funds-eeb12d5952a99dcfa9d029d1e80d1711.png";